import $ from "jquery";
import moment from "moment/moment";
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import init from '../AccessControl/Check';
import { CSVLink } from "react-csv";
import number_format from "../../../components/Constants/NumberFormat";


import DatePickerV2 from "./../../../components/Date/DatePicker-v2";
import DatePickerRange from "./../../../components/Date/DatePickerRange";
import { toast } from "react-toastify";

import Popup from "./../../../components/Popup";
import { ReactComponent as CloseBtn } from './../../../assets/icons/close.svg';
import UserBasicInfoContext from "../../../components/Context/UserBasicInfoContext";
import { SUPER_ADMIN_CODE } from './../ConstRole/ConstRole';

const AllVoucher = () => {

    const pageName = "Order View";
    const isAccess = init(pageName);

    const userProfile = useContext(UserBasicInfoContext);

    const [show, setShow] = useState(false);
    useEffect(() => {
        if (show === false) {
            return;
        }

        setTimeout(() => {
            setShow(false);
        }, 8000);
    }, [show]);

    // checkPIN
    const [voucherPIN, setvoucherPIN] = useState('')
    const checkPIN = event => {
        if (voucherPIN === "8520") {
            setShow(true);
            toast.success("This voucher code stay for 8 seconds");
        }
        else{
            toast.error("You have entered an invalid PIN");
        }
    };

    var setDatePicker = () => {
        $("#date-div").hide();
        $("#date-range-div").hide();

        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);


        var v = $("#date-range-data").val();
        if (v === "custom") {
            $("#date-range-div").show();
        }
        else if (v === "all") {
            $("#date-div").attr("style", "display:flex");
        }
    }

    const [orderList, setOrderList] = useState([]);
    const [summary, setSummary] = useState({
        purchase: 0,
        redeem: 0,
        expire: 0
    });

    const [isFilter, setIsFilter] = useState(false);
    const [reqParam, setReqParam] = useState({
        page: 1
    })


    const filterClick = () => {
        $("#filter-toggle-icon").toggleClass("rotate-180");
        $(".custom-btn.filter").toggleClass("active");

        $("#filter-div").toggleClass("need-without-shadow");
        $("#filter-div").toggleClass("no-need-without-shadow");
    }

    const [apiData, setApiData] = useState({});

    useEffect(() => {
        // Get All Voucher List
        PostLoginGetApi("voucher/offer/logs", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setOrderList(responseData["data"]["list"]);
                    setSummary(responseData["data"]["summary"]);

                    setExcelData([]);
                    return;
                }

                toast.error(responseData["messages"].toString() ?? "A problem occur. Please try again");
            }
        }).catch((err) => {
            console.log(err);
        })

    }, [isFilter, reqParam]);


    // Get Brand Lists
    const [brandList, setBrandList] = useState([]);
    useEffect(() => {
        PostLoginGetApi("voucher/brand", "", 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setBrandList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }, []);

    // Excel Download
    const [excelData, setExcelData] = useState([]);
    const excelPrepare = () => {

        let i = 0;
        let arr = [];
        arr[i++] = ['', 'VOUCHER HISTORY REPORT'];
        arr[i++] = ['', 'DOWNLOAD AT', moment().format('DD MMM, YYYY hh:mm A')];
        arr[i++] = [];


        // Get All Orders List
        PostLoginGetApi("voucher/offer/logs-all", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);


                if (responseData["code"] === 200) {

                    let sum = { 'payable': 0, 'commission': 0, 'net': 0 };
                    let data = responseData["data"]["list"] ?? [];
                    let summary = responseData["data"]["summary"] ?? [];


                    arr[i++] = ['', 'OVERALL SUMMARY'];
                    arr[i++] = ['', 'PURCHASED', summary?.purchase ?? 0];
                    arr[i++] = ['', 'UNUSED', summary?.unused ?? 0];
                    arr[i++] = ['', 'REDEEMED', summary?.redeem ?? 0];
                    arr[i++] = ['', 'EXPIRED', summary?.expire ?? 0];


                    arr[i++] = [];
                    arr[i++] = ['', 'FILTER BY'];
                    arr[i++] = ['', 'DATES', 'FROM', reqParam.from ?? "", 'TO', reqParam.end ?? ""];
                    arr[i++] = ['', 'STATUS', reqParam.status ?? "ALL"];
                    arr[i++] = ['', 'SETTLEMENT TYPES', reqParam.settlement ?? "ALL"];
                    arr[i++] = ['', 'BRAND', reqParam.brand ?? "ALL"];
                    arr[i++] = ['', 'SEARCH BY PHONE', reqParam.phone ?? ""];
                    arr[i++] = ['', 'SEARCH BY TRANSACTION ID', reqParam.code ?? ""];

                    arr[i++] = [];
                    arr[i++] = [];
                    arr[i++] = ['SNO', 'DATE TIME', 'TRANSACTION ID', 'CUSTOMER NAME', 'CUSTOMER PHONE', 'CUSTOMER PHONE', 'OFFER NAME', 'BRAND NAME', 'PURCHASE TYPE', 'VOUCHER STATUS', 'SETTLEMENT STATUS',
                        'FACE VALUE ({process.env.REACT_APP_CURRENCY_SYMBOL})', 'AMOUNT ({process.env.REACT_APP_CURRENCY_SYMBOL})', 'SETTLEMENT CHARGE ({process.env.REACT_APP_CURRENCY_SYMBOL})', 'PAYABLE AMOUNT ({process.env.REACT_APP_CURRENCY_SYMBOL})'];



                    data.forEach((val) => {
                        // Set CSV Data Arr
                        arr[i++] = [val.sno, moment(val.created_at).format("DD MMM, YYYY hh:mm A"), val.booking_code, val.sender_name, val.sender_phone.toString() + " ", val.sender_email, val.offer_name, val.brand_name, val.purchase_option, val.booking_status, val.settlement,
                        val.offer_face_value, val.total_price, val.commission, val.net_amount];

                        sum.payable += val.total_price ?? 0;
                        sum.commission += val.commission_amount ?? 0;
                        sum.net += val.net_amount ?? 0;
                    });


                    arr[i] = ['', 'TOTAL', '', '', '', '', '', '', '', '', '', '', number_format(sum.payable ?? 0, 2), number_format(sum.commission ?? 0, 2), number_format(sum.net ?? 0, 2)];

                    setExcelData(arr);
                }
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            return true;
        });
    }


    const pagination = (next = 1) => {
        if (next === 1) {
            setReqParam({ ...reqParam, page: reqParam.page + 1 });
            return;
        }

        if (reqParam.page > 1) {
            setReqParam({ ...reqParam, page: reqParam.page - 1 });
            return;
        }

        setReqParam({ ...reqParam, page: 1 });
        return;
    }

    const filter = () => {

        reqParam.page = 1;
        reqParam.phone = $("#search-by-phone").val() ?? "";
        reqParam.code = $("#search-by-booking-id").val() ?? "";
        reqParam.status = $("#status").val() ?? "";
        reqParam.settlement = $("#settlement").val() ?? "";

        reqParam.brand = $("#brand").val() ?? "";


        // Date Filter
        let from = "", end = "";
        if ($("#date-range-data").val() === "custom") {
            from = $("#fromDate").val();
            end = $("#toDate").val();

            if (from.length === 0 || end.length === 0) {
                from = "";
                end = "";
            }
            else {
                let nextDate = new Date(end);
                nextDate.setDate(nextDate.getDate() + 1);
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");
                end = nextDate;
            }
        }
        else if ($("#date-range-data").val() === "all") {
            const singleDatePicker = $("#singleDatePicker").val();
            if (singleDatePicker.length !== 0) {
                let nextDate = new Date(singleDatePicker);
                nextDate.setDate(nextDate.getDate() + 1);
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");

                from = singleDatePicker;
                end = nextDate;
            }
        }


        reqParam.from = from;
        reqParam.end = end;

        setReqParam({ ...reqParam });
        setIsFilter(true);
    }


    const resetFilterData = () => {

        $("#date-range-data").val("custom");
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
        $("#to-date-picker").val("");


        $("#settlement").val('all');
        $("#brand").val('all');
        $("#status").val('all');
        $("#search-by").val("search-by-phone");
        $("#search-by-phone").val("");
        $("#search-by-booking-id").val("");

        $("#search-by-booking-id").hide();
        $("#search-by-phone").show();

        $("#date-div").hide();
        $("#date-range-div").show();

        filter();
        setIsFilter(false);
    }


    const setSearchParam = () => {
        $("#search-by-phone").val("");
        $("#search-by-booking-id").val("");

        const search_by = $("#search-by").val();
        $("#search-by-phone").hide();
        $("#search-by-booking-id").hide();

        $("#" + search_by).show();
        $("#" + search_by).focus();
    }


    const [popUpData, setPopUpData] = useState({});
    const [isTermsShow, setIsTermsShow] = useState(false);
    const closeModel = () => {
        setIsTermsShow(false);
        setPopUpData({});
    }
    const openModel = (data) => {
        setPopUpData({
            ...popUpData,
            bookingId: data.booking_id ?? "",
            code: data.code ?? "",
            redeemDate: moment(data.date).format("DD MMM, YYYY hh:mm A") ?? "",
            status: data.status ?? ""
        });
        setIsTermsShow(true);
    }


    if (isAccess === false) {
        // return (<>
        //     <table className="custom-details-table w-full mt-0 mb-2">
        //         <tbody>
        //             <tr>
        //                 <td className="font-semibold text-base">
        //                     You do not have any access !
        //                 </td>
        //             </tr>
        //         </tbody>
        //     </table>
        // </>);
    }


    return (
        <div className="custom-container w-full font-montserrat flex">

            {/** Left Side */}
            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] pb-2 pt-0">
                    <div className="w-1/2 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-1 pt-6 mb-5">Here’s your voucher history at a glance</h6>
                    </div>

                    <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">

                        {(excelData.length === 0) ?
                            <button onClick={excelPrepare} className="custom-btn mr-2 text-center">Prepare CSV</button>
                            :
                            <CSVLink className="custom-btn mr-2 text-center" filename={"voucher-history-report.csv"} onClick={() => { return true; }} data={excelData}>
                                Export CSV
                            </CSVLink>
                        }


                        <Link to="#" onClick={filterClick} className="custom-btn filter text-center w-[92px]">Filter</Link>
                        <svg id="filter-toggle-icon" className='static -ml-4' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="#1A202C" />
                            <path d="M17 19L13 15L17 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F5F5F5" />
                        </svg>
                    </div>
                </div>

                <div className="w-full flex overflow-hidden text-left py-4 pt-2">
                    <div className="box hover-black-green w-1/4 py-5 h-auto mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Orders
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary?.purchase ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto mr-[1%]  bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Unused
                        </Link>

                        <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary?.unused ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto mr-[1%]  bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Redeemed / Used
                        </Link>

                        <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary?.redeem ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Expired
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary?.expire ?? 0}</h3>
                    </div>
                </div>


                {/* DATA TABLE */}
                <div className="flex flex-col w-full pt-2">
                    <div className='-m-1.5 overflow-x-auto pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className="border rounded-lg shadow overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200 custom-table-hover">
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left'>
                                            <th scope="col" className="px-4 py-3 text-center">#</th>
                                            <th scope="col" className="px-3 py-3">Transaction</th>
                                            <th scope="col" className="px-3 py-3">Customer</th>
                                            <th scope="col" className="px-3 py-3">Offer & Brand</th>
                                            <th scope="col" className="px-2 py-3 text-center">Status</th>
                                            <th scope="col" className="px-2 py-3 text-center">Settlement</th>
                                            <th scope="col" className="px-2 py-3 text-center">Face Value</th>
                                            <th scope="col" className="px-2 py-3 text-center">Amount</th>
                                            <th scope="col" className="px-2 py-3 text-center">Charge</th>
                                            <th scope="col" className="px-2 py-3 text-center">Payable</th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200'>
                                        {(orderList.length === 0) &&
                                            <tr key="0">
                                                <td className='px-6 py-1 text-center' colSpan={10}>
                                                    <p className='py-4'>No voucher booked yet</p>
                                                </td>
                                            </tr>
                                        }


                                        {orderList.map((data, index) => (
                                            (data !== null) &&
                                            <tr key={index}>
                                                <td className='py-4 text-center border-r-2 font-semibold'>{data.sno ?? ++index}</td>
                                                <td className='px-3 py-4 border-r-2'>
                                                    <Link className='cursor-pointer text-blue-500 font-semibold'
                                                        onClick={() => openModel({
                                                            booking_id: data.booking_code,
                                                            code: data.code,
                                                            status: data.booking_status,
                                                            voucer_code: data.voucher_code,
                                                            date: data.redeem_date
                                                        })} >
                                                        {data.booking_code}
                                                    </Link>
                                                    <br />{moment(data.created_at).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                <td className='px-3 py-4 border-r-2'>
                                                    {data.sender_name ?? "N/A"}
                                                    <br />
                                                    {data.sender_phone}
                                                </td>
                                                <td className='px-3 py-4 border-r-2'>
                                                    {data.offer_name}<br />
                                                    {data.brand_name}
                                                </td>
                                                <td className='px-2 py-4 border-r-2 text-center'>
                                                    {data.booking_status}
                                                </td>
                                                <td className='px-2 py-4 border-r-2 text-center'>{data.settlement}</td>
                                                <td className='px-2 py-4 border-r-2 text-center'>{number_format(data.offer_face_value ?? 0, 2)}</td>
                                                <td className='px-2 py-4 border-r-2 text-center'>{number_format(data.total_price ?? 0, 2)}</td>
                                                <td className='px-2 py-4 border-r-2 text-center'>{number_format(data.commission_amount ?? 0, 2)}</td>
                                                <td className='px-2 py-4 text-center'>{process.env.REACT_APP_CURRENCY_SYMBOL} {number_format(data.net_amount ?? 0, 2)}</td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>

                            </div>
                            {/* Pagination */}
                            {(apiData?.meta?.from) !== undefined &&
                                <>
                                    <p className='float-left mt-7'>
                                        {`Showing ${apiData?.meta?.from * 1} - ${apiData?.meta?.to * 1} out of ${apiData?.meta?.total * 1}`}
                                    </p>


                                    {(apiData?.links?.next !== null && apiData?.links?.next !== "") &&
                                        <button onClick={() => pagination(1)} className="custom-btn float-right mt-5 ml-2">
                                            Next Page&nbsp;&nbsp;&rarr;
                                        </button>
                                    }

                                    {(apiData?.links?.prev !== null && apiData?.links?.prev !== "") &&
                                        <button onClick={() => pagination(0)} className="custom-btn float-right mt-5">
                                            &larr;&nbsp;&nbsp;Previous Page
                                        </button>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>

            </div>

            {/* Right Side */}
            <div id="filter-div" className="custom-container-right float-right w-1/5 pl-2 pb-10 pt-4 pr-1 justify-center custom-scroll-auto mb-20 no-need-without-shadow">
                <div className="relative">
                    <h6 className="text-lg px-3 font-base pb-2 pl-2" style={{ boxShadow: "0 3px 0 0 rgb(0 0 0 / 1%)" }}>Filter Orders</h6>


                    <div className="box-full w-full  text-justify py-2 pl-2">
                        <div className="w-full float-left pt-2">
                            <select onChange={setDatePicker} id="date-range-data" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="custom">
                                <option value="all">Single Date</option>
                                <option value="custom">Date Range</option>
                            </select>
                            <DatePickerV2 />
                            <DatePickerRange />
                        </div>
                    </div>

                    <div className="box-full block w-full h-full text-justify pl-2">
                        <div className="w-full float-left pb-1 pt-6">
                            <select id="status" className='w-full mt-0 mb-2 bg-[#F5F5F5] rounded border-0'>
                                <option value="all">All Statuses</option>
                                <option value="Accepted">Unused</option>
                                <option value="Completed">Redeemed / Used</option>
                                <option value="Expired">Expired</option>
                            </select>
                        </div>
                    </div>

                    <div className="box-full block w-full h-full text-justify  pl-2">
                        <div className="w-full float-left pb-1 pt-0">
                            <select id="settlement" className='w-full mt-0 mb-2 bg-[#F5F5F5] rounded border-0'>
                                <option value="all">Settlement Types</option>
                                <option value="0">Due</option>
                                <option value="1">Processed</option>
                                <option value="2">Settled</option>
                            </select>
                        </div>
                    </div>

                    <div className="box-full block w-full h-full text-justify  pl-2">
                        <div className="w-full float-left pb-1 pt-0">
                            <select id="brand" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0'>
                                <option value="all">All Brand</option>
                                {brandList.map((val, index) => (
                                    <option key={index} value={val?.id}>{val?.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>


                    <div className="box-full flex w-[97%] h-full text-justify py-0.5 px-0.5 -mt-2 ml-2 mb-4 bg-[#F5F5F5] rounded">
                        <div className="w-full h-full float-left">
                            <select id="search-by" className='w-full mt-0 mb-0.5 bg-[#F5F5F5] rounded border-0' defaultValue="search-by-phone" onChange={setSearchParam}>
                                <option value="search-by-phone">Search by Phone</option>
                                <option value="search-by-booking-id">Search by Booking Id</option>
                            </select>


                            <input type="text" id="search-by-phone" onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                                autoComplete='off' className="custom-search-fields w-full text-base border-0 rounded placeholder:text-ash" title="01xxxxxxxxx" placeholder='Customer Phone' maxLength={11} />

                            <input type="text" id="search-by-booking-id" autoComplete='off' className="hidden custom-search-fields w-full text-base border-0 rounded placeholder:text-ash" placeholder='Booking Id' maxLength={20} />
                        </div>
                    </div>

                    <button onClick={filter} className="custom-btn w-[97%] flow-root float-left ml-2 mt-2">Filter</button>
                    {isFilter && <button onClick={resetFilterData} className="custom-btn ml-2 mt-3 flow-root w-[97%] float-left bg-black text-white border-black" style={{ color: "#FFF" }}>Reset Filter</button>}

                </div>
            </div>


            {/* Model Window */}
            {(isTermsShow === true) &&
                <div>
                    <Popup content={
                        <form className="p-5 font-medium">
                            <div className="flex justify-between">
                                <h3 className="text-xl text-black font-semibold">Voucher Information</h3>
                                <CloseBtn className="cursor-pointer" onClick={closeModel} />
                            </div>

                            <div className='max-w-lg mt-6 pr-1 whitespace-break-spaces'>
                                <table id="voucher-details-table" className="custom-details-table w-full mt-0 mb-5">
                                    <tbody>
                                        <tr>
                                            <td className="font-semibold text-base w-[180px]">Booking Id</td>
                                            <td className="px-5 text-base">{popUpData?.bookingId}</td>
                                        </tr>
                                        {(userProfile?.user_type_id === SUPER_ADMIN_CODE) &&
                                            <tr>
                                                <td className="font-semibold text-base">Code</td>
                                                <td className="px-5 text-base">
                                                    {show ?
                                                        <>{popUpData?.code}</>
                                                        :
                                                        <>
                                                            <input type="password" autoComplete='off' id="voucherPIN" placeholder="PIN" name="voucherPIN" className='w-[150px] mr-1 float-left  border-none bg-[#F5F5F5] rounded-l' onChange={(e) => setvoucherPIN(e.target.value)} />
                                                            <button type="button" className="w-[60px] text-white bg-primary p-2 mb-2 rounded cursor-pointer hover:bg-brand-dark button button1" onClick={() => {
                                                                // setShow(true);
                                                                checkPIN();
                                                            }} >Show</button>
                                                        </>
                                                    }

                                                </td>

                                            </tr>
                                        }
                                        <tr>
                                            <td className="font-semibold text-base">Status</td>
                                            <td className="px-5 text-base">{popUpData?.status}</td>
                                        </tr>
                                        {(popUpData?.status === "Redeemed") &&
                                            <tr>
                                                <td className="font-semibold text-base">Redeem Date</td>
                                                <td className="px-5 text-base">{popUpData?.redeemDate}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>

                        </form>}
                    />
                </div>
            }

        </div>
    );


};

export default AllVoucher;